"use strict";

$(document).ready(() => {

    var iz_text = $('.iz_text').val();
    iz_text = (iz_text != undefined) ? iz_text : '/';
    var loader_text = $('.loader_text').val();

    $('body').on('click', '.key-areas__button', function() {
        $('.key-areas__button').removeClass('active');
        $('.key-areas__image')
            .removeClass('active')
            .eq($(this).addClass('active').index())
            .addClass('active');
    });

    $('.services__list').slick({
        infinite: true,
        centerMode: false,
        slidesToShow: 3,
        speed: 300,
        swipe: false,
        prevArrow: '.services__left',
        nextArrow: '.services__right',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.portfolio__list').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide != undefined ? currentSlide : slick.options.initialSlide) + 1;
        $(this).closest('.portfolio').find('.portfolio__counter').text(i + ' ' + iz_text + ' ' + slick.slideCount);
    }).slick({
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        variableWidth: true,
        initialSlide: 0,
        speed: 300,
        prevArrow: '.portfolio__left',
        nextArrow: '.portfolio__right',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    variableWidth: false,
                    centerMode: false,
                },
            },
        ],
    });

    $('.cooperation__list').slick({
        infinite: true,
        centerMode: false,
        slidesToShow: 3,
        variableWidth: true,
        speed: 300,
        prevArrow: '.cooperation__left',
        nextArrow: '.cooperation__right',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    variableWidth: false,
                },
            },
        ],
    });

    $('.gallery').each(function() {
        $(this).find('.gallery__list').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
            var i = (currentSlide != undefined ? currentSlide : slick.options.initialSlide) + 1;
            $(this).closest('.gallery').find('.gallery__counter').text(i + ' ' + iz_text + ' ' + slick.slideCount);
        }).on('init', function(event, slick, currentSlide, nextSlide) {
            if(slick.slideCount > slick.options.slidesToShow) {
                $(this).closest('.gallery').find('.gallery__navigate').show();
            }
        }).slick({
            infinite: true,
            centerMode: false,
            slidesToShow: 2,
            variableWidth: false,
            speed: 300,
            prevArrow: '.gallery__left',
            nextArrow: '.gallery__right',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });

    $('.gallery2').each(function() {
        $(this).find('.gallery2__list').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
            var i = (slick.currentSlide != undefined ? slick.currentSlide : slick.options.initialSlide) + 1;
            $(this).closest('.gallery2').find('.gallery2__counter').text(i + ' ' + iz_text + ' ' + slick.slideCount);
        }).on('init', function(event, slick, currentSlide, nextSlide) {
            if(slick.slideCount > slick.options.slidesToShow) {
                $(this).closest('.gallery2').find('.gallery2__navigate').show();
            }
        }).slick({
            infinite: true,
            centerMode: false,
            slidesToShow: 3,
            variableWidth: false,
            speed: 300,
            prevArrow: '.gallery2__left',
            nextArrow: '.gallery2__right',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });

    $('body').on('change', '.project-filter__select', function() {
        get_projects($(this).val());
    });

    $('.project-filter__select').val($('.project-filter__select option').eq(1).val());
    $('body').on('click', '.project-filter__button', function() {
        $('.project-filter__select').val(0);
        get_projects(0);
    });

    function get_projects(direction_id) {
        $.ajax({
            url: ajax.url,
            type: 'post',
            data: {
                action: 'project_filter',
                direction_id: direction_id,
            },
            beforeSend: function() {
                $('.projects-section .portfolio__tile').html('<div class="preloader">' + loader_text + '</div>');
            },
            success: function(data) {
                $('.projects-section .portfolio__tile').html(data);
            }
        });
    }

    $('body').on('submit', '#callback_form', function(e) {
        try {
            e.preventDefault();
            let $this = $(this);
            let data = {
                action: 'callback_form',
            };
            $this.find('input[type="text"]').each(function() {
                let val = $(this).val();
                if(val == '') throw new Error('Поле «'+$(this).attr('name')+'» пустое');
                data[$(this).attr('name')] = val;
            });
            $.ajax({
                url: ajax.url,
                type: 'post',
                data: data,
                success: function(data) {
                    $this.find('input[type="text"]').each(function() {
                        $(this).val('');
                    });
                    $('.success-window').fadeIn();
                }
            });
        } catch(error) {
            $(this).find('input[type="text"]').each(function() {
                if($(this).val() == '') $(this).addClass('error');
            });
        }
    });

    $('body').on('keyup change touchend mouseup', '#callback_form input[type="text"]', function() {
        if($(this).val().length) $(this).removeClass('error');
    });

    $('body').on('click', '.close-window', function() {
        $(this).closest('.window').fadeOut();
    });

    $('body').on('click', '.open-menu', function() {
        $('body').toggleClass('active-menu');
    });

    $(window).on('scroll', function() {
        if($(this).scrollTop() > ($(window).height() / 2)) {
            $('.to-top').fadeIn();
        } else {
            $('.to-top').fadeOut();
        }
    });

    $('body').on('click', '.to-top', function() {
        $("html, body").stop().animate({scrollTop:0}, 500, 'swing');
    });
});



